import { RouteRecordRaw } from 'vue-router';
import { IRouteConfigAuthMeta } from '@/shared';

const auth: IRouteConfigAuthMeta = {
  required: true,
};

export default [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/main/Home.vue'),
    meta: {
      auth,
      title: 'Dashboard',
      icon: 'tachometer-fast',
      active: false,
      noPagePadding: false,
      hidePageTitle: true,
      hideFromNav: false,
    },
  },
  {
    path: '/privacy-policy',
    beforeEnter(to, from, next) {
      window.location.href = 'https://rentsync.com/cookie-policy';
    },
  },
  {
    path: '/cookie-policy',
    beforeEnter(to, from, next) {
      window.location.href = 'https://rentsync.com/cookie-policy';
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/main/NotFound.vue'),
    meta: {
      auth,
      icon: 'exclamation-circle',
      title: 'Page Not Found!',
    },
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('@/views/main/Unauthorized.vue'),
    meta: {
      auth,
      icon: 'exclamation-circle',
      title: 'Unauthorized!',
    },
  },
  {
    // Vue Router 4 removed the bare `*` catch-all; matches must use a param with a custom regexp.
    path: '/:pathMatch(.*)*',
    name: 'Redirect',
    redirect: '/404',
    meta: {
      auth,
      title: '404Redirect',
    },
  },
  {
    path: '/internal-page',
    name: 'Internal Page',
    component: () => import('@/views/support/InternalPage.vue'),
    meta: {
      auth,
      title: 'Internal Page',
      hideFromNav: false,
      hidePageTitle: true,
      icon: 'cogs',
      active: false,
    },
  },
  {
    path: '/maintenance-mode',
    name: 'Maintenance',
    component: () => import('@/views/main/MaintenanceSplash.vue'),
    meta: {
      title: 'Undergoing Maintenance',
      active: false,
      hideBlade: true,
    },
  },
  {
    path: '/client-switch',
    name: 'Client Switch',
    component: () => import('@/views/client-switch/index.vue'),
    meta: {
      auth: {
        required: true,
        permissions: ['superuser'],
      },
      title: 'Client Switch',
      active: false,
      noPagePadding: false,
      hidePageTitle: true,
      hideFromNav: true,
    },
  },
] as RouteRecordRaw[];
